import * as React from "react";
import {
  Grid,
  Header,
  Icon,
  Popup,
  Segment,
  SemanticICONS,
  SemanticSIZES,
} from "semantic-ui-react";
import { IconSizeProp } from "semantic-ui-react/dist/commonjs/elements/Icon/Icon";
import { ColorProp } from "../../../constants/type";
import { Link, LinkRouter } from "../button";
export interface ISectionContainer {
  size?: "small" | "medium" | "large";
  shade?: ColorProp;
  title?: string;
  titleComponent?: any;
  style?: any;
  children: any;
  footer?: any;
  iconName?: SemanticICONS;
  fluid?: boolean;
  basic?: boolean;
  stretch?: boolean;
  padded?: boolean | "very";
  onClick?: () => void;
  styleContent?: any;
  linkLabel?: string;
  linkRouterLabel?: string;
  linkRouterPathName?: string;
  linkModalLabel?: string;
  linkModalComponent?: any;
  linkPopupLabel?: string;
  loading?: boolean;
  rightActions?: React.ReactNode;
}

interface ISizeStyle {
  sizeHeader: "tiny" | "small" | "medium" | "large" | "huge";
  sizeLink: SemanticSIZES;
  sizeIcon: IconSizeProp | undefined;
}

class SectionContainer extends React.Component<ISectionContainer> {
  public render() {
    const {
      title,
      titleComponent,
      children,
      linkLabel,
      footer,
      fluid,
      linkRouterLabel,
      linkModalLabel,
      styleContent,
      basic,
      stretch,
      padded,
      loading,
      style,
      rightActions,
    } = this.props;
    const sizeStyle = this.getSize();
    const fullContent = fluid ? styles.segment : undefined;

    return (
      <Grid padded={stretch ? false : true} style={style}>
        {!title &&
        !titleComponent &&
        !linkLabel &&
        !linkRouterLabel &&
        !linkModalLabel ? null : (
          <Grid.Row
            columns={
              (title || titleComponent) &&
              (linkLabel || linkRouterLabel || linkModalLabel || rightActions)
                ? 2
                : 1
            }
            verticalAlign="middle"
          >
            {title || titleComponent ? (
              <Grid.Column floated="left" textAlign="left">
                {title ? (
                  <Header size={sizeStyle.sizeHeader} style={styles.header}>
                    {title}
                  </Header>
                ) : null}
                {titleComponent || null}
              </Grid.Column>
            ) : null}
            {linkLabel || linkRouterLabel || linkModalLabel || rightActions ? (
              <Grid.Column floated="right" textAlign="right">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                    gap: "1rem",
                  }}
                >
                  {rightActions}
                  {linkLabel ? this.renderLinkLabel() : null}
                  {linkRouterLabel ? this.renderLinkRouter() : null}
                  {linkModalLabel ? this.renderLinkModal() : null}
                </div>
              </Grid.Column>
            ) : null}
          </Grid.Row>
        )}

        {children && children !== null && children !== "" ? (
          <Grid.Row columns={1} style={{ ...styles.row }}>
            <Grid.Column>
              <Segment
                padded={padded}
                basic={basic}
                style={{ ...styleContent, ...fullContent }}
                loading={loading}
              >
                {children}
              </Segment>
            </Grid.Column>
          </Grid.Row>
        ) : null}
        {footer ? (
          <Grid.Row columns={1} style={styles.row}>
            <Grid.Column floated="right" textAlign="right">
              {footer}
            </Grid.Column>
          </Grid.Row>
        ) : null}
      </Grid>
    );
  }
  private onClick = () => {
    const { onClick } = this.props;
    if (typeof onClick !== "undefined") {
      onClick();
    }
  };

  private getSize = () => {
    const { size } = this.props;
    const style: ISizeStyle = {
      sizeHeader: "medium",
      sizeLink: "large",
      sizeIcon: "large",
    };
    switch (size) {
      case "small":
        style.sizeHeader = "tiny";
        style.sizeLink = "tiny";
        style.sizeIcon = undefined;
        break;
      case "medium":
        style.sizeHeader = "medium";
        style.sizeLink = "large";
        style.sizeIcon = "large";
        break;
      case "large":
        style.sizeHeader = "large";
        style.sizeLink = "big";
        style.sizeIcon = "big";
        break;
      default:
        style.sizeHeader = "medium";
        style.sizeLink = "large";
        style.sizeIcon = "large";
        break;
    }
    return style;
  };

  private renderLinkLabel = () => {
    const sizeStyle = this.getSize();
    const { shade, linkLabel, iconName, linkPopupLabel } = this.props;
    return (
      <Popup
        content={linkPopupLabel}
        disabled={!linkPopupLabel}
        position={"top right"}
        trigger={
          <React.Fragment>
            <Link
              shade={shade || 2}
              size={sizeStyle.sizeLink}
              onClick={this.onClick}
            >
              {linkLabel}
            </Link>
            {iconName ? (
              <Icon
                size={sizeStyle.sizeIcon}
                link
                name={iconName}
                //className="primary"
                onClick={this.onClick}
                style={{ ...styles.icon }}
              />
            ) : null}
          </React.Fragment>
        }
      />
    );
  };

  private renderLinkRouter = () => {
    const sizeStyle = this.getSize();
    const {
      shade,
      linkRouterLabel,
      iconName,
      linkRouterPathName,
      linkPopupLabel,
    } = this.props;
    return (
      <Popup
        content={linkPopupLabel}
        disabled={!linkPopupLabel}
        position={"top right"}
        trigger={
          <LinkRouter
            shade={shade || 2}
            size={sizeStyle.sizeLink}
            path={linkRouterPathName!}
          >
            {linkRouterLabel}
            <Icon
              size={sizeStyle.sizeIcon}
              link
              name={iconName || "chevron right"}
              // //className="primary"
              onClick={this.onClick}
              style={{ ...styles.icon }}
            />
          </LinkRouter>
        }
      />
    );
  };

  private renderLinkModal = () => {
    const sizeStyle = this.getSize();
    const {
      shade,
      iconName,
      linkModalComponent,
      linkModalLabel,
      linkPopupLabel,
    } = this.props;
    return (
      <React.Fragment>
        {React.cloneElement(linkModalComponent, {
          trigger: (
            <Popup
              content={linkPopupLabel}
              disabled={!linkPopupLabel}
              position={"top right"}
              trigger={
                <Link
                  shade={shade || 2}
                  size={sizeStyle.sizeLink}
                  onClick={this.onClick}
                >
                  {linkModalLabel}
                  {iconName ? (
                    <Icon
                      size={sizeStyle.sizeIcon}
                      link
                      name={iconName}
                      //className="primary"
                      onClick={this.onClick}
                      style={{ ...styles.icon }}
                    />
                  ) : null}
                </Link>
              }
            />
          ),
        })}
      </React.Fragment>
    );
  };
}

const styles = {
  row: {
    paddingTop: 0,
  },
  icon: {
    marginLeft: 8,
    marginRight: 0,
    textDecoration: "none",
  },
  segment: {
    padding: 0,
  },
  header: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: "90%",
  },
};

export default SectionContainer;
